import { render, staticRenderFns } from "./VariableTableList2.vue?vue&type=template&id=7aed8b21&"
import script from "./VariableTableList2.vue?vue&type=script&lang=ts&"
export * from "./VariableTableList2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports